import { CONSIGNMENT_BRANCH_SETTING_TAB } from "@/core/helpers/consignmentBranchSettingTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Shown as a Store Settings tab.
export const Route = createFileRoute(
	"/admin/consignment-vendor-application-invite/",
)({
	beforeLoad() {
		throw redirect({
			to: "/admin/consignment-branch-setting",
			search: { tab: CONSIGNMENT_BRANCH_SETTING_TAB.PilotInvites },
			replace: true,
		});
	},
});
